import Vue from 'vue'

export default [
  {
    path: '/household/',
    component: () => import('@/components/Layer.vue'),
    children: [
      {
        path: '',
        redirect: { name: 'householdProperty' }
      },
      {
        path: 'property',
        name: 'householdProperty',
        component: () => import('@/views/Household/PropertyView.vue'),
        meta: {
          prev: 'goHome'
        }
      },
      {
        path: 'detail/:id',
        name: 'householdDetail',
        component: () => import('@/views/Household/DetailView.vue'),
        meta: {
          prev: 'mainPage/comOpenServiceStatus'
        }
      },
      {
        path: 'detail/',
        redirect: { name: 'householdProperty' }
      }
    ],
    beforeEnter: (to, from, next) => {
      if (!localStorage.getItem('loginUserInfo') && !JSON.parse(localStorage.getItem('loginUserInfo'))) {
        Vue.prototype.$alert('請重新登入', '警告', {
          confirmButtonText: '確定',
          type: 'warning',
          showClose: false,
          roundButton: true,
          closeOnClickModal: false
        }).then(() => {
          next({ name: 'LoginMain' })
        })
      } else {
        next()
      }
    }
  }
]
